import React, { useEffect } from "react";
import about from "../assets/heights.mp4";
import risk from "../assets/risk.png"
import buy from "../assets/buy.png"
import takeRisk from "../assets/taking-risk.png"
import stopLoss from "../assets/stop-loss.png"
import prediction from "../assets/prediction.png"
const About = () => {
  
  return (
    <div className="">
      <section className="relative h-screen flex flex-col items-center justify-center text-center text-white">
      {/* Video Background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <video
          className="min-w-full min-h-full absolute object-cover"
          src={about}
          type="video/mp4"
          autoPlay
          muted
          loop
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        ></video>
        <div
          style={{
            content: '""',
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            background: "rgba(17, 20, 22, 0.6)",
            zIndex: 1,
          }}
        ></div>
      </div>

      {/* Video Content */}
      <div className="z-10 space-y-2">
        <div class="flex flex-1 w-full flex-col items-center justify-center text-center px-4 py-20 ">
          <h1 class="mx-auto max-w-7xl font-display lg:text-5xl text-4xl font-bold tracking-normal text-white-300 dark:text-gray-300 sm:text-7xl">
            Our client-first approach guides
            <span class="relative whitespace-nowrap text-white-600 dark:text-gray-300">
              {" "}
              you towards
            </span>
            <span class="relative whitespace-nowrap text-orange-500 dark:text-orange-300">
              <svg
                aria-hidden="true"
                viewBox="0 0 418 42"
                class="absolute top-2/3 left-0 h-[0.58em] w-full fill-orange-500 dark:fill-orange-300/60"
                preserveAspectRatio="none"
              >
                <path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.780 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.540-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.810 23.239-7.825 27.934-10.149 28.304-14.005 .417-4.348-3.529-6-16.878-7.066Z"></path>
              </svg>
              <span class="relative"> financial success </span>
            </span>
          </h1>
          <h2 class="mx-auto mt-12 max-w-4xl text-lg sm:text-white-400 text-white-500 dark:text-gray-300 leading-7">
            We strive to set new benchmarks in the financial sector through
            practical, efficient, and cost-effective models. By providing robust
            research, personalized service, and cutting-edge technology, we aim
            to be your trusted partner in the journey to financial prosperity.
          </h2>
        </div>
      </div>
      
    </section>
    {/* seggetion */}
    <div className=" flex w-full bg-white lg:justify-center lg:items-center lg:content-center">
    <div className=" w-[80%] h-auto flex flex-col justify-center">
          <div className="lg:flex  w-full pt-10  lg:px-0 mx-3">
            <div className="lg:w-[70%] sm:w-full flex lg:  ">
              <h3 className="text-2xl  w-full text-start">Never trade with your entire capital in one single trade in order to avoid big losses.</h3>
            </div>
            <div className="lg:w-[20%] sm:w-full flex justify-center lg:pl-10 mt-6 lg:mt-0">
              <img src={risk} alt="" className="w-[80%]" />
            </div>
          </div>
          <div className="lg:flex  w-full pt-10  lg:px-0 mx-3">
          <div className="lg:w-[70%] sm:w-full flex  items-center order-last">
            <h3 className="text-2xl tracking-wide ">Don't let emotions drive your trading decisions.</h3>
            </div>
            <div className="lg:w-[20%] sm:w-full flex justify-center mt-6 lg:mt-0 ">
              <img src={buy} alt="" className="w-[80%]"/>
            </div>
            
          </div>
          <div className="lg:flex  w-full pt-10  lg:px-0 mx-3">
            <div className="lg:w-[70%] sm:w-full flex items-center">
            <h3 className="text-2xl tracking-wide ">Don't ignore proper risk management strategies.</h3>
            </div>
            <div className="lg:w-[20%] sm:w-full flex justify-center  lg:mt-0 mt-6">
              <img src={takeRisk} alt="" className="w-[80%]" />
            </div>
          </div>
          <div className="lg:flex  w-full pt-10  lg:px-0 mx-3">
          <div className="lg:w-[70%] sm:w-full flex justify-center items-center order-last">
            <h3 className="text-2xl tracking-wide">Don't overlook the importance of setting stop-loss orders to protect your investments.</h3>
            </div>
            <div className="lg:w-[20%] sm:w-full flex justify-center lg:mt-0 mt-6 ">
              <img src={stopLoss} alt="" className="w-[80%]" />
            </div>
            
          </div>
          <div className="lg:flex  w-full pt-10  lg:px-0 mx-3">
            <div className="lg:w-[70%] sm:w-full flex justify-center items-center content-center">
            <h3 className="text-2xl tracking-wide">Don't try to predict the market's direction with absolute certainty even experts can't do it consistently </h3>
            </div>
            <div className="lg:w-[20%] sm:w-full flex justify-center lg:mt-0 mt-6">
              <img src={prediction} alt="" className="w-[80%]"  />
            </div>
          </div>
      </div>
    </div>
    </div>
    
  );
};

export default About;
